import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import { Loading } from 'components';

import { formatDate } from 'app/utils';

const { REACT_APP_UNSECURE_COOKIE } = process.env;

const Incarnate = () => {
  const [, setCookie] = useCookies(['token']);

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  useEffect(() => {
    var token = searchParams.get('token');
    var expiresAt = searchParams.get('expiresAt');

    const unsecureCookie =
      REACT_APP_UNSECURE_COOKIE === 'true' || window.location.hostname === 'localhost';

    setCookie('token', token, {
      path: '/',
      domain: window.location.hostname,
      expires: formatDate(expiresAt).toDate(),
      secure: !unsecureCookie,
    });

    navigate('/');
  });

  return <Loading label="Por favor, aguarde." />;
};

export default Incarnate;
